import React from 'react';
import CrmDonorFeaturesPage from '../components/CrmDonorFeaturesPage';

const CrmDonorFeaturesApp = (props) => (
  <CrmDonorFeaturesPage {...props} />
);

export default CrmDonorFeaturesApp;
